import React from 'react';
import classNames from 'classnames';
import quoteSuccess from 'src/assets/quote-success-graphic.svg';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import styled from 'src/ui/library/styled';
import PropTypes from 'prop-types';

const styles = theme => ({
  hasError: {
    border: `solid 1px ${theme.colors.red}`,
  },
});

class QuoteSuccess extends React.Component {
  static propTypes = {
    hasError: PropTypes.bool,
  };
  static defaultProps = {
    hasError: false,
  };
  state = {
    imageIsReady: false,
  };

  componentDidMount() {
    // this was done because the text would cause a UI defect positioning text
    // in an image that was not loaded yet
    const img = new Image();
    img.src = quoteSuccess;
    img.onload = () => {
      this.setState({ imageIsReady: true });
    };
  }

  render() {
    const { value, currCode, quote, helpText, hasError, classes, className } = this.props;
    const rootClass = classNames({ [classes.hasError]: hasError }, className);
    const valueLength = value && value.length;
    let quoteSuccessClass = '';
    if (valueLength > 6) {
      quoteSuccessClass = 'val-length-8';
    } else if (7 > valueLength && valueLength > 3) {
      quoteSuccessClass = 'val-length-6';
    }

    if (!this.state.imageIsReady) return null;

    return (
      <div className={`quote-parent-div ${rootClass}`}>
        {helpText && <InfoTooltip toolTipText={helpText} className="quote-info" />}
        <div className="quote-wrapper">
          <div className={classNames('quote-success', quoteSuccessClass)}>
            <img alt="success" src={quoteSuccess} />
            <span className="quote-currency">{currCode}</span>
            <div className="quote-success-content"> {value}</div>
            <span className="quote-desc">{quote}</span>
          </div>
        </div>
      </div>
    );
  }
}

// business asked us to remove the extra grids so I am commenting them out for now
// just incase it was a mistake - gregn
// return (
//   <Grid container className="quote-parent-div">
//       {helpText && <InfoTooltip toolTipText={helpText} className="quote-info" />}
//       <Grid item xs={12} sm={6} md={6} lg={6} className="quote-wrapper" >
//           <div className='quote-success'>
//               <img src={quoteSuccess} />
//               <span className="quote-currency">{currCode}</span>
//               <div className="quote-success-content"> {value}</div>
//               <span className="quote-desc">{quote}</span>
//           </div>
//       </Grid>
//       <Grid item xs={12} sm={3} md={3} lg={3} className="quote-label-wrapper" >
//           <div className="quote-label">
//               This is your quote to have your tax return prepared through EY TaxChat
//           </div>
//       </Grid>
//       <Grid item xs={12} sm={3} md={3} lg={3} className="quote-label-wrapper-1" >
//           <div className="quote-label-1">
//               No need to pay now! You'll pay at the end of the process once your return is finalized.
//           </div>
//       </Grid>
//   </Grid>
// );

export { QuoteSuccess };
export default styled(QuoteSuccess)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/controls/QuoteControl/QuoteSuccess.js